// @ts-nocheck
document.addEventListener('DOMContentLoaded', function () {
  const swiperEl = document.querySelector('.single-animal__swiper');
  if (!swiperEl) return;

  const swiper = new Swiper('.single-animal__swiper', {
    slidesPerView: 1,
    loop: false,
    allowTouchMove: true,
    preventClicks: false,
    preventClicksPropagation: false,
    navigation: {
      nextEl: '.single-animal__nav--next',
      prevEl: '.single-animal__nav--prev',
    },
  });

  const thumbs = document.querySelectorAll('.single-animal__thumb');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      const index = parseInt(thumb.dataset.index, 10);
      swiper.slideTo(index);
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  swiper.on('slideChange', function () {
    thumbs.forEach(function (t) { t.classList.remove('is-active'); });
    const active = document.querySelector('.single-animal__thumb[data-index="' + swiper.activeIndex + '"]');
    if (active) active.classList.add('is-active');
  });

  document.querySelectorAll('.single-animal__accordion-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.classList.toggle('is-open');
      btn.nextElementSibling.classList.toggle('is-open');
    });
  });
});
